import { TransformationDefinitionDTO } from "../DTO/transformationDefinitionDTO";
import { BasicRequest } from "./basicRequest";

export class CreateTransformationDefinitionRequest extends BasicRequest{
   
    public transformationDefinition! : TransformationDefinitionDTO;
    
    constructor(){
        super();
    }
}